import React from 'react';
import moment from 'moment';
import ChosenPassengerDetail from './ChosenPassengerDetail';
import { ReactComponent as Edit } from '../../../../../../../resources/images/svg/editNote.svg';
import { ReactComponent as Delete } from '../../../../../../../resources/images/svg/delete.svg';
import ChosenPassengerAction from './ChosenPassengerAction';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function ChosenPassenger({
  passenger,
  handleDelete,
  handleChooseEdit,
}) {
  const {
    birth_date, first_name, id_number, last_name, id,
  } = passenger;
  const { trans } = useTranslation();
  return (
    <div
      className="bg-white rounded-2xl px-[44px] py-[23px] w-full max-w-[1532px] flex flex-col gap-5 lg:flex-row lg:justify-between"
    >
      <div className="flex flex-col gap-5 lg:gap-[46px] lg:flex-row">
        <div className="flex justify-between gap-5 flex-wrap lg:gap-[46px] ">
          <ChosenPassengerDetail title={trans('date_of_birth')} text={birth_date ? moment(birth_date).format('DD.MM.YYYY') : ''} />
          <ChosenPassengerDetail title={trans('personal_number')} text={id_number} />
        </div>
        <div className="flex flex-col gap-[13px] text-xl custom-font">
          <span className="font-bold text-base">
            {trans('first_name')}
            {' '}
            {trans('last_name')}
          </span>
          {`${first_name} ${last_name}`}
        </div>
      </div>
      <div className="flex justify-between flex-wrap lg:justify-normal gap-[20px]">
        <ChosenPassengerAction
          icon={<Edit className="fill-primary" />}
          text={trans('edit')}
          handleClick={() => handleChooseEdit(id)}
        />
        <ChosenPassengerAction
          icon={<Delete />}
          text={trans('delete')}
          handleClick={() => handleDelete(id)}
        />
      </div>
    </div>
  );
}

export default ChosenPassenger;
